import { render, staticRenderFns } from "./SensorTile.vue?vue&type=template&id=1c3396f6&scoped=true&"
import script from "./SensorTile.vue?vue&type=script&lang=js&"
export * from "./SensorTile.vue?vue&type=script&lang=js&"
import style0 from "./SensorTile.vue?vue&type=style&index=0&id=1c3396f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3396f6",
  null
  
)

export default component.exports